<template>
    <b-nav small pills align="around">
        <b-nav-item class="flex-1" :to="{name: 'consultations'}"
                    link-classes="rounded-pill p-1 bg-light-skyler text-muted border-2 border-light-skyler" exact
                    exact-active-class="active">
            <div class="d-flex align-items-center">
                <div class="font-weight-bold flex-fill text-center">
                    {{t('Consultations')}}
                </div>
            </div>
        </b-nav-item>

        <b-nav-item class="flex-1 mx-3" :to="{name: 'labs'}"
                    link-classes="rounded-pill p-1 bg-light-skyler text-muted border-2 border-light-skyler" exact
                    exact-active-class="active">
            <div class="d-flex align-items-center">
                <div class="font-weight-bold flex-fill text-center">
                    {{t('Labs')}}
                </div>
            </div>
        </b-nav-item>

        <b-nav-item class="flex-1" :to="{name: 'vaccine'}"
                    link-classes="rounded-pill p-1 bg-light-skyler text-muted border-2 border-light-skyler" exact
                    exact-active-class="active">
            <div class="d-flex align-items-center">
                <div class="font-weight-bold flex-fill text-center">
                    {{t('Vaccines')}}
                </div>
            </div>
        </b-nav-item>
    </b-nav>
</template>

<script>
    import INeedle from "../Icons/INeedle";
    import ITubeWhite from "../Icons/ITubeWhite";
    import IConversation from "../Icons/IConversation";

    export default {
        name: "RecordsNav",
        components: {
            ITubeWhite, INeedle, IConversation
        }
    }
</script>

<style scoped>
    .active {
        background-color: #3266F5 !important;
        color: #ffffff !important;
        border-color: #3266F5 !important;
    }
</style>
